import React, { Fragment } from "react"

let CodeFour = () => {

    return (
        <Fragment>
            <div className="cell code-cell">
                <div className="ace-github">
                    <div className="ace_static_highlight">
                        <div className="ace_line"><span className="ace_keyword">import</span> <span
                            className="ace_identifier">Router</span> <span className="ace_identifier">from</span>
                            <span className="ace_string">"framework/alto/router"</span><span
                                className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_storage ace_type">let</span> <span
                            className="ace_identifier">router</span> <span
                            className="ace_keyword ace_operator">=</span> <span
                            className="ace_identifier">Router</span><span
                            className="ace_punctuation ace_operator">.</span><span
                            className="ace_identifier">create</span><span
                            className="ace_paren ace_lparen">{`({`}</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_identifier">routes</span><span
                            className="ace_punctuation ace_operator">:</span> <span
                            className="ace_paren ace_lparen">{`{`}</span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span> <span className="ace_indent-guide">    </span><span
                            className="ace_identifier">todos</span><span
                            className="ace_punctuation ace_operator">:</span>
                            <span className="ace_paren ace_lparen">{`{`}</span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    <span className="ace_indent-guide">    </span></span><span
                            className="ace_indent-guide">    </span> <span
                            className="ace_comment">// more to come</span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_indent-guide">    </span> <span
                            className="ace_paren ace_rparen">{`}`}</span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_paren ace_rparen">{`}`}</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_paren ace_rparen">{`})`}</span><span
                            className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_keyword">export</span> <span
                            className="ace_keyword">default</span> <span className="ace_identifier">router</span><span
                            className="ace_punctuation ace_operator">;</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ace_line"><br/></div>
        </Fragment>
    )

};

export default CodeFour;